import type { ReportingTab } from "@/lib/states/global-state"

export interface ReportingTabItem {
	value: ReportingTab
	label: string
	productlaneOnly?: boolean
}

export const REPORTING_TABS: readonly ReportingTabItem[] = [
	{ value: "overview", label: "Overview" },
	{ value: "conversations", label: "Conversations" },
	{ value: "team", label: "Team" },
	{ value: "responsiveness", label: "Responsiveness" },
	{ value: "slas", label: "SLAs", productlaneOnly: true },
	{ value: "feedback", label: "Feedback" },
]

export const isReportingTab = (value: string): value is ReportingTab =>
	REPORTING_TABS.some((tab) => tab.value === value)

export const getReportingTabs = (options: {
	isProductlaneWorkspace: boolean
}): ReportingTabItem[] =>
	REPORTING_TABS.filter(
		(tab) => !tab.productlaneOnly || options.isProductlaneWorkspace,
	)

export const normalizeReportingTab = (
	value: string,
	options?: { isProductlaneWorkspace?: boolean },
): ReportingTab => {
	const isProductlane = options?.isProductlaneWorkspace !== false
	if (value === "slas" && !isProductlane) return "overview"
	if (isReportingTab(value)) return value
	return "overview"
}
